import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  NgModule,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '@uw/core/base.component';
import { MatTableModule } from '@angular/material/table';

import { EmployeeSearchFilter } from '@uw/modules/campaign/models/employee-filter.model';
import { SharedModule } from '@uw/shared/shared.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { PaidUnpaidTransactionListComponent } from './paid-unpaid-transaction-list/paid-unpaid-transaction-list.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { EmployeeSearchFilterComponent } from './employee-search-filter/employee-search-filter.component';
import {
  ColumnsConfig,
  FilterButtonsMap as FilterButtonsLabelMap,
  FilterCriterias,
  TransactionType,
} from '@uw/core/models/paid-unpaid-checklist.models';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressBarModule, MatProgressBar } from '@angular/material/progress-bar';
import { NoRecordContainerComponent } from '../no-record-container/no-record-container.component';
import { UwButtonComponent } from '../button/button.component';

@Component({
    selector: 'uw-paid-unpaid-checklist-page',
    templateUrl: './paid-unpaid-checklist-page.component.html',
    styleUrls: ['./paid-unpaid-checklist-page.component.scss'],
    imports: [EmployeeSearchFilterComponent, NoRecordContainerComponent, PaidUnpaidTransactionListComponent, UwButtonComponent, MatProgressBar, TranslateModule]
})
export class PaidUnpaidChecklistPageComponent
  extends BaseComponent
  implements OnInit
{
  employeeSearchFilter: EmployeeSearchFilter | null = null;

  @Input()
  donationFormGroup!: UntypedFormGroup;

  @Input()
  columnsConfig!: ColumnsConfig;

  @Input()
  filterButtonLabelMap!: FilterButtonsLabelMap;

  @Input()
  isSaving!: boolean;

  @Output()
  page = new EventEmitter();

  @Output()
  save = new EventEmitter();

  @Output()
  filter = new EventEmitter();

  noRecords!: boolean;

  @Input()
  isLoading!: boolean;

  constructor() {
    super();
  }

  get donations() {
    return this.donationFormGroup?.controls['donations'] as UntypedFormArray;
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {

    if (changes && changes.donationFormGroup && changes.donationFormGroup.currentValue) {
      this.noRecords = this.donations.value.length === 0;
    }
  }

  filterTransactions(transactionType: TransactionType) {
    let filterCriterias: FilterCriterias = {};
    if (transactionType == 'sentTransactions') {
      filterCriterias = { ...filterCriterias, isPaid: true };
    } else if (transactionType == 'unsentTransactions') {
      filterCriterias = { ...filterCriterias, isPaid: false };
    }
    this.filter.emit(filterCriterias);
  }

  onSubmit() {
    this.save.emit(this.donationFormGroup?.value);
  }

  onSearch(filter: EmployeeSearchFilter) {
    this.employeeSearchFilter = filter;

    let filterCriterias: FilterCriterias = {
      employeeId: filter.employeeId,
      lastName: filter.lastName,
      firstName: filter.firstName,
    };

    this.filter.emit(filterCriterias);
  }

  onClearSearchFilter() {
    this.employeeSearchFilter = null;
    this.pagination = { page: 0, limit: 10 };
    this.updatePaginationQueryParameters();
  }

  onPageChange() {
    this.page.emit();
  }
}

@NgModule({
    exports: [PaidUnpaidChecklistPageComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatButtonModule,
        TranslateModule,
        MatCheckboxModule,
        MatSortModule,
        MatTableModule,
        MatDatepickerModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        SharedModule,
        NgxMaskDirective, NgxMaskPipe,
        EmployeeSearchFilterComponent,
        PaidUnpaidTransactionListComponent,
        PaidUnpaidChecklistPageComponent
    ],
    providers: [provideNgxMask()]
})
export class PaidUnpaidChecklistModule {}
